var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#909A9F",
    d: "M11.048 6.876C9.716 6.056 8 7.014 8 8.579v24.842c0 1.565 1.716 2.523 3.048 1.703l20.184-12.42a2 2 0 0 0 0-3.407z"
  })));
};
export { SvgPlay as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjA0ODIgNi44NzU4MUM5LjcxNTY1IDYuMDU1NzkgOCA3LjAxNDQ5IDggOC41NzkxM1YzMy40MjA5QzggMzQuOTg1NSA5LjcxNTY2IDM1Ljk0NDIgMTEuMDQ4MiAzNS4xMjQyTDMxLjIzMjEgMjIuNzAzM0MzMi41MDEyIDIxLjkyMjMgMzIuNTAxMiAyMC4wNzc3IDMxLjIzMjEgMTkuMjk2N0wxMS4wNDgyIDYuODc1ODFaIiBmaWxsPSIjOTA5QTlGIi8+Cjwvc3ZnPgo=";